import { createSelector } from 'reselect';
import { formatScale } from './utils';
export const makeGetItems = () => {
    return createSelector([(state, componentIdent) => state[componentIdent].scales], (scales) => {
        return scales.map((value) => ({
            value,
            label: formatScale(value),
        }));
    });
};
//# sourceMappingURL=selectors.js.map